window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

const language = window.lang_test_language
const locale = document.documentElement.lang

export default class Api {
}

Api.getFirstStep= function () {
    return axios.post('/lang-test/first-step', {language})
}

Api.getStep = function (stepId) {
    return axios.post('/lang-test/step/' + stepId, {language})
}

Api.getNextStepFor = function (stepId) {
    return axios.post('/lang-test/next-for/' + stepId, {language})
}

Api.getStepsCount = function () {
    return axios.post('/lang-test/steps-count/', {language})
}

Api.collectLead = function (contacts, answers) {
    return axios.post('/lang-test/submit', {contacts, answers, language, locale})
}
